import type { QuestionFamily } from '@/core/types';
import type { SubjectPack, TopicDef } from '../../pack';

/**
 * Early-years (Grade 1–4) content that plugs into an existing subject pack:
 * extra topics per domain, their question families, and extra prerequisite
 * edges from existing skills down to the new foundations.
 */
export interface EarlyAddon {
  topics: Record<string, TopicDef[]>;
  families: QuestionFamily[];
  pre?: Record<string, string[]>;
}

export function withEarly(pack: SubjectPack, addon: EarlyAddon): SubjectPack {
  const domains = pack.domains.map((d) => {
    const extra = addon.topics[d.id];
    const topics = d.topics.map((t) => ({
      ...t,
      skills: t.skills.map((s) => (addon.pre?.[s.id] ? { ...s, pre: [...(s.pre ?? []), ...addon.pre[s.id]] } : s)),
    }));
    return extra ? { ...d, topics: [...extra, ...topics] } : { ...d, topics };
  });
  const missing = Object.keys(addon.topics).filter((id) => !pack.domains.some((d) => d.id === id));
  if (missing.length) throw new Error(`withEarly: unknown domain(s) ${missing.join(', ')} in ${pack.subject.id}`);
  return { ...pack, domains, families: [...addon.families, ...pack.families] };
}
